import { useState, useMemo, useRef } from 'react';
import throttle from 'lodash/throttle';
import { useResizeObserver } from '../useResizeObserver';
import { useLayoutEffectWithoutSSRComplaining } from '../useLayoutEffectWithoutSSRComplaining';
// an optional cache to keep measurements while component is unmounted
// this allows to immediately start in the right state while mounting,
// without needing to wait for the measurement
// make sure the key use is unique enough for the instance you are caching
// it for (eg. deviationid by itself is not enough, componentname-deviationid
// might work)
var cache = {};
export function useIsOverflowed(ref, throttleTimeout, cacheKey) {
    var _a;
    if (throttleTimeout === void 0) { throttleTimeout = 300; }
    var isReady = useRef(false);
    var _b = useState((_a = cache[cacheKey !== null && cacheKey !== void 0 ? cacheKey : '']) !== null && _a !== void 0 ? _a : false), isOverflowed = _b[0], setIsOverflowed = _b[1];
    var measure = useMemo(function () {
        return throttle(function () {
            var contentNode = ref.current;
            var containerNode = contentNode === null || contentNode === void 0 ? void 0 : contentNode.parentNode;
            if (!contentNode || !containerNode) {
                return;
            }
            var isOverflowedNow = contentNode.getBoundingClientRect().height >
                containerNode.getBoundingClientRect().height;
            setIsOverflowed(isOverflowedNow);
            if (cacheKey) {
                cache[cacheKey] = isOverflowedNow;
            }
        }, throttleTimeout, { trailing: true });
    }, [throttleTimeout, ref, cacheKey]);
    useResizeObserver(ref, measure);
    useLayoutEffectWithoutSSRComplaining(function () {
        measure();
        isReady.current = true;
    }, [measure]);
    return { isOverflowed: isOverflowed, isReady: isReady.current };
}
//# sourceMappingURL=useIsOverflowed.js.map